<template>
    <div>
        <CRow>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>آمار درگاه‌ها</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable
                            hover
                            striped
                            columnFilter
                            :items="items"
                            :fields="fields"
                            :items-per-page="15"
                            :active-page="active_page"
                            :pagination="{ doubleArrows: true, align: 'center'}"
                            :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }"
                        >
                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>
<script>
export default {
    data () {
        return {
            items: [],
            fields: [
                { key: 'key', label: 'درگاه' },
                { key: 'all_messages_count', label: 'تعداد پیام‌ها' },
                { key: 'all_messages_sms_fee', label: 'هزینه پیام‌ها' },
                { key: 'blocked_messages_count', label: 'تعداد لیست سیاه' },
                { key: 'blocked_messages_sms_fee', label: 'هزینه لیست سیاه' },
                { key: 'delivered_messages_count', label: 'تحویل داده شده' },
                { key: 'delivered_messages_sms_fee', label: 'هزینه پیام ارسالی (delivered)' },
                { key: 'error_messages_count', label: 'تعداد خطا' },
                { key: 'error_messages_sms_fee', label: 'هزینه خطا' },
                { key: 'reject_messages_count', label: 'رد شده' },
                { key: 'reject_messages_sms_fee', label: 'هزینه رد شده' },
                { key: 'returned_fee', label: 'هزینه بازگشتی (خطا)' },
                { key: 'timeout_messages_count', label: 'رسیده به مخابرات' },
                { key: 'timeout_messages_sms_fee', label: 'هزینه رسیده به مخابرات' },
                { key: 'undelivered_messages_count', label: 'تحویل داده نشده' },
                { key: 'undelivered_messages_sms_fee', label: 'هزینه تحویل داه نشده' },
                { key: 'undelivered_returned_fee_for_delivery_base_line', label: 'هزینه بازگشتی (delivery base)' },
                { key: 'undelivered_returned_fee_for_undelivery_base_line', label: '---' },
                { key: 'unknown_messages_count', label: 'تعداد نامشخص' },
                { key: 'unknown_messages_sms_fee', label: 'هزینه نامشخص' },
            ],
            active_page: 1,
        }
    },
    mounted(){
        this.get();
    },
    methods: {
        get() {
            let user, from, to, state;
            this.$route.params.user == 0 ? user = '' : user = this.$route.params.user;
            this.$route.params.from == 0 ? from = '' : from = this.$route.params.from;
            this.$route.params.to == 0 ? to = '' : to = this.$route.params.to;
            this.$route.params.state == 0 ? state = '' : state = this.$route.params.state;
            if(this.$route.params.type == 'single'){
                this.axios.get('user_statistics/' 
                    + '?id=' + this.$route.params.id
                    + '&user_id=' + user
                    + '&from_statistics_date=' + from
                    + '&to_statistics_date=' + to
                    + '&is_final=' + state
                    + '&user_info=1')
                    .then(res => {
                        res.data.map(val => {
                            val['items'] = [];
                            for (const key in val.user_statistics.gateway_infos){
                                const item = {};
                                item.key = key;
                                for (const k in val.user_statistics.gateway_infos[key]){
                                    if(k == 'undelivered_returned_fee_for_delivery_base_line'
                                        || k == 'undelivered_returned_fee_for_undelivery_base_line'
                                        || k == 'returned_fee'){
                                            item[k] = String(val.user_statistics.gateway_infos[key][k]).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    } else {
                                        if(this.$route.params.count_type == '1'){
                                            item[`${k}_count`] = String(val.user_statistics.gateway_infos[key][k].page_count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        } else if(this.$route.params.count_type == '2') {
                                            item[`${k}_count`] = String(val.user_statistics.gateway_infos[key][k].count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                        }
                                        item[`${k}_sms_fee`] = String(val.user_statistics.gateway_infos[key][k].sms_fee).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    }
                                }
                                val['items'].push(item);
                            }
                        });
                        this.items = res.data[0].items;
                    })
            } else if(this.$route.params.type == 'all'){
                this.axios.get('user_statistics/' 
                    + '?all_statistics=1'
                    + '&user_id=' + user
                    + '&from_statistics_date=' + from
                    + '&to_statistics_date=' + to
                    + '&is_final=' + state)
                    .then(res => {
                        res.data['items'] = [];
                        for (const key in res.data.gateway_infos){
                            const item = {};
                            item.key = key;
                            for (const k in res.data.gateway_infos[key]){
                                if(k == 'undelivered_returned_fee_for_delivery_base_line'
                                    || k == 'undelivered_returned_fee_for_undelivery_base_line'
                                    || k == 'returned_fee'){
                                        item[k] = String(res.data.gateway_infos[key][k]).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                } else {
                                    if(this.$route.params.count_type == '1'){
                                        item[`${k}_count`] = String(res.data.gateway_infos[key][k].page_count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    } else if(this.$route.params.count_type == '2') {
                                        item[`${k}_count`] = String(res.data.gateway_infos[key][k].count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    }
                                    item[`${k}_sms_fee`] = String(res.data.gateway_infos[key][k].sms_fee).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                }
                            }
                            res.data['items'].push(item);
                        }
                        this.items = res.data.items;
                    })
            }
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.view_user_info_statistics == false
            && this.$store.state.perms.view_all_users_statistics == false
            && this.$store.state.perms.view_same_group_users_statistics == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
